<!--
  - 首页主要内容组件
  - 当前设计为一屏滚动
-->

<template>
	<div class="main">
		<div class="bl-content">
			<!-- 在线运行代码 -->
			<div class="bl-slide bl-runcode">
				<h2 id="tag-runcode">在线运行代码</h2>
				<div class='sub'>
					<!-- 介绍 -->
					<Row>
						<div class="introduce">
							<Col span="14">
								<div class="left">
									<div class="text">
										<h4>代码片段在线执行并立即查看输出结果，逃离繁琐的创建文件、保存运行的苦恼。</h4>
										<h4>将短暂想法与思路保存在字节社上，以便随时查验结果。</h4>
										<h4>将逻辑规则保存下来，下次传参即用，解放繁琐的加解密算法等执行结果。</h4>
										<h4>将公开的代码片段分享出去，点击即运行。解决交流中代码排版与验证运行的困难。</h4>
									</div>
									<div class="goto">
										<Button type="success" class="wow slideInLeft"
										        @click="active({name: 'Build', params: {lang: 'php7'}})">
											点击前往
											<Icon type="chevron-right"></Icon>
										</Button>
									</div>
								</div>
							</Col>
							<Col span="8">
								<div class="right">
									<div class="bl-show">
										<img src="/static/index/main_show_png/show_runcode.png"/>
									</div>
								</div>
							</Col>
						</div>
					</Row>
					<!-- 子列表 -->
					<div class="items wow fadeInUp">
						<Items @click="active" :group="runcode_items"/>
					</div>
				</div>
			</div>
			
			<!-- 管理工具 -->
			<div class="bl-slide bl-manager">
				<h2 id="tag-system">系统管理工具</h2>
				<div class="list">
					<div v-for="it in service_items" v-if="it.is_show" class="item ivu-card ivu-card-bordered">
						<Row>
							<div class="header">
								<Col span="2">
									<div class="icon">
										<svg :class="it.class" aria-hidden="true">
											<use :xlink:href="it.icon"></use>
										</svg>
									</div>
								</Col>
								<Col span="15" offset="1">
									<div class="title">
										<h3>{{it.title}}</h3>
									</div>
									<div class="content" style="margin-top: 20px;">
										<h5>{{it.desc}}</h5>
									</div>
								</Col>
							</div>
						</Row>
						<div class="footer" v-if="it.items.length > 0">
							<Row>
								<div v-for="x in it.items">
									<Col span="3">
										<div class='item_icon' @click="active(x)" @mouseenter="icon_enter_animate"
										     @mouseleave="icon_leave_animate">
											<svg width="35%" height="30px" :class="x.class" aria-hidden="true">
												<use :xlink:href="x.icon"></use>
											</svg>
										</div>
										<div class="item_text">
											<h5>{{x.title}}</h5>
										</div>
									</Col>
								</div>
							</Row>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 前端工具 -->
			<div class="bl-slide bl-type-items bl-frontend">
				<h2 id="tag-frontend">前端工具</h2>
				<div class="group" v-for="item in frontend_items">
					<div class="list">
						<div class='item' @click="active(it)" v-for="it in item" @mouseenter="icon_enter_animate"
						     @mouseleave="icon_leave_animate">
							<div class="top" style="align-items: center;flex-direction: row;padding:20px 0;">
								<svg height="45px" :class="it.class" aria-hidden="true">
									<use :xlink:href="it.icon"></use>
								</svg>
							</div>
							<div class="text" style="text-align: center;">
								<h4>{{it.title}}</h4>
							</div>
							<div class="desc" style="text-align: center;">
								{{it.desc}}
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 其他工具 -->
			<div class="bl-slide bl-type-items bl-other">
				<h2 id="tag-other">其他工具</h2>
				<div class="group" v-for="item in other_items">
					<div class="list">
						<div class='item' @click="active(it)" :class="{ 'show': it.title }" v-for="it in item"
						     @mouseenter="icon_enter_animate" @mouseleave="icon_leave_animate">
							<div class="top" style="align-items: center; flex-direction: row; padding: 20px 0;">
								<svg height="45px" :class="it.class" aria-hidden="true">
									<use :xlink:href="it.icon"></use>
								</svg>
							</div>
							<div class="text" style="text-align: center;">
								<h4>{{it.title}}</h4>
							</div>
							<div class="desc" style="text-align: center;">
								{{it.desc}}
							</div>
						</div>
					</div>
				</div>
			</div>
		
		</div>
	</div>
</template>

<script>
	import Items from './items'
	// import '@/assets/css/icon/build.css'
	// import '@/assets/svg/build.js'
	import '@/assets/svg/iconfont.js'
	import '@/assets/svg/qrcode/iconfont.js'

	export default {
		name: 'Main',
		data(){
			return {
				runcode_items: [
					{
						type: '脚本类语言',
						list: [
							{
								name: 'Build',
								params: {lang: "php7"},
								title: '运行PHP7',
								icon: '#icon-php',
								class: 'icon icon-php',
							},
							{
								name: 'Build',
								params: {lang: "python"},
								title: '运行Python',
								icon: '#icon-python',
								class: 'icon icon-python'
							},
							{
								name: 'Build',
								params: {lang: "node"},
								title: '运行Nodejs',
								icon: '#icon-nodejs',
								class: 'icon icon-nodejs'
							},
							{
								name: 'Build',
								params: {lang: "shell"},
								title: '运行Shell',
								icon: '#icon-shell',
								class: 'icon icon-shell'
							},
							{
								name: 'Build',
								params: {lang: "lua"},
								title: '运行Lua',
								icon: '#icon-lua',
								class: 'icon icon-lua'
							},
							{
								name: 'Build',
								params: {lang: "perl"},
								title: '运行Perl',
								icon: '#icon-go',
								class: 'icon icon-perl'
							}
						]
					},
					{
						type: '编译类语言',
						list: [
							{
								name: 'Build',
								params: {lang: "cpp"},
								title: '运行C++',
								icon: '#icon-cpp',
								class: 'icon icon-cpp'
							},
							{
								name: 'Build',
								params: {lang: "c"},
								title: '运行C',
								icon: '#icon-c-lang',
								class: 'icon icon-c'
							},
							{
								name: 'Build',
								params: {lang: "golang"},
								title: '运行Golang',
								icon: '#icon-gopher',
								class: 'icon icon-gotitle'
							},
							{
								name: 'Build',
								params: {lang: "java"},
								title: '运行Java',
								icon: '#icon-java',
								class: 'icon icon-java'
							},
							{
								name: 'Build',
								params: {lang: "ruby"},
								title: '运行Ruby',
								icon: '#icon-ruby',
								class: 'icon icon-ruby'
							}
						]
					}
				],
				service_items: [
					{
						title: 'Linux主机管理工具',
						desc: '提供主流Liux发行版本管理工具。',
						class: 'icon icon-linux',
						icon: '#icon-linux',
						is_show: true,
						items: [
							// {
							// 	icon: '#icon-zhuji',
							// 	class: 'icon icon-zhuji',
							// 	name: 'DashboardServer',
							// 	title: '主机管理',
							// },
							// {
							//   icon: '#icon-zhujiyonghumimapiliangxiugai-',
							//   class: 'icon icon-zhujiyonghumimapiliangxiugai',
							//   title: '用户管理',
							// },
							{
								icon: '#icon-ssh',
								name: 'OnlineSsh',
								class: 'icon icon-ssh',
								title: 'SSH直连',
							},
							// {
							//   icon: '#icon-timer',
							//   class: 'icon icon-timer',
							//   title: '定时任务',
							// },
							// {
							//   icon: '#icon-fuwuguanli',
							//   class: 'icon icon-fuwuguanli',
							//   title: '服务管理',
							// },
						],
					},
					{
						title: 'PHPmyadmin管理工具',
						desc: '提供在线PHPmyadmin。提供管理列表，一键连接与登录远程数据库，管理Mysql数据库的访问与操作。',
						class: 'icon icon-mysql',
						icon: '#icon-mysql',
						is_show: false,
						items: [
							{
								icon: '#icon-timer',
								class: 'icon icon-timer',
								title: '数据库管理',
							},
						],
					}
				],
				frontend_items: [
					[
						{
							icon: '#icon-html',
							class: 'icon icon-html',
							title: '前端格式化',
							name: 'ToolHtml',
							desc: '对前端代码进行美化，语法高亮显示'
						},
						{
							icon: '#icon-jiami2',
							class: 'icon icon-jiami2',

							title: 'JS混淆加密',
							name: 'ToolEncode',
							desc: '提供js的混淆、压缩、混淆加密功能'
						},
						{
							icon: '#icon-es',
							class: 'icon icon-es',
							title: 'ES5/6/7转换',
							name: 'ToolTransfer',
							desc: '对ES5 / 6 / 7 标准js进行相互转换'
						},
						{
							icon: '#icon-less',
							class: 'icon icon-less',
							title: 'Less/Sass预处理',
							name: 'ToolLess',
							desc: '在线对Less/Sass进行预处理构建'
						},
					],
					// [
					//   {
					//     icon: '#icon-typescript',
					//     class: 'icon icon-typescript',
					//     title: 'TypeScript / CoffeeScript',
					//     href: '/frontend/typescript',
					//     desc: '在线对TypeScript/CoffeeScript进行转译'
					//   },
					// ]
				],
				other_items: [
					[
						{
							icon: '#icon-json',
							class: 'icon icon-json',
							title: 'JSON格式化',
							name: 'ToolJson',
							desc: '对Json代码进行格式化显示，颜色高亮'
						},
						// {
						//   icon: '#icon-encrypt',
						//   class: 'icon icon-encrypt',
						//   title: '数据编解码',
						//   href: '/tools/crypto',
						//   desc: '提供Bcrypt / md5 / sha-* 等常用加解密功能'
						// },
						// {
						//   icon: '#icon-yasuo',
						//   class: 'icon icon-yasuo',
						//   title: '图片压缩',
						//   desc: '图片进行压缩，较tinypng有更大压缩比'
						// },
						{
							icon: '#icon-markdown',
							class: 'icon icon-markdown',
							title: '在线Markdown编辑',
							name: 'ToolMarkdown',
							desc: '实时预览markdown文字，一键导出'
						},
						{
							icon: '#icon-qrcode',
							class: 'icon icon-qrcode',
							title: '二维码在线识别',
							name: 'ToolQrcode',
							desc: '在线解析二维码图片'
						},
					]
				]
			};
		},
		methods: {
			icon_enter_animate(event){
				$(event.target).find('svg').css({'top': -10});
			},
			icon_leave_animate(event){
				$(event.target).find('svg').css({'top': 0});
			},
			active(item){
				this.$router.push({
					name: item.name,
					params: item.params,
				})
			},
		},
		components: {
			Items,
		},
		created(){
			this.$nextTick(function(){
			})
		}
	}
</script>

<style scoped lang="less">
	@import "../../../../src/theme/default";
	
	.main {
		padding: 0 150px 50px 150px;
		
		.bl-runcode {
			.text {
				font-size: 13px;
			}
			
			.sub {
				.right {
					position: relative;
					top: -50px;
				}
			}
			
			.goto {
				margin-top: 50px;
			}
		}
		
		h2 {
			font-size: 30px;
			margin-top: 50px;
			margin-bottom: 50px;
		}
		
		.bl-show {
			img {
				box-shadow: 0 15px 30px rgba(0, 0, 0, 1);
				transform: translate3d(0, -2px, 0);
				width: 100%;
				height: 100%;
				border-radius: 10px;
			}
		}
		
		.bl-manager {
			.item {
				padding: 20px 50px;
				
				.item_icon {
					cursor: pointer;
				}
			}
			
			.header {
				svg {
					width: 100%;
					height: 100%;
				}
				
				.icon {
					height: 50px;
				}
			}
			
			.footer {
				border-top: 1px solid #eee;
				margin-top: 30px;
				padding-top: 20px;
			}
		}
		
		.bl-frontend, .bl-other {
			.list {
				display: flex;
				flex-direction: row;
				/*justify-content: space-between;*/
				align-items: flex-start;
				flex-wrap: wrap;
			}
			
			.item {
				cursor: pointer;
				padding: 20px 0;
			}
			
			.item:hover {
				box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
			}
		}
		
		svg {
			transition: top 0.5s ease 0s;
			position: relative;
			top: 0;
		}
	}

</style>
